<template>
    <div class="provider-stats">
        <div class="browser">
            <div class="browser-left">
                <g-field
                    v-model="provider"
                    class="provider-picker"
                    name="providers"
                    placeholder="Proveedor"
                    type="relation"
                    table="providers"
                    ret-label="name"
                    @input="changeProvider"
                />
                <year-select
                    v-model="selectedYears"
                    :minYear="$moment().year() - yearsInThePast"
                    :maxSelection="1"
                    placeholder="Selecionar temporada"
                />
            </div>
            <div class="browser-right">
                <a-button @click="handlerCleanFilter">
                    <fa-icon :icon="['fas', 'broom-wide']" />
                </a-button>
                <a-button
                    type="primary"
                    @click="handlerFilter"
                    :disabled="(!provider || !provider.key) && !selectedYears.length"
                    :loading="isLoading"
                >
                    <fa-icon v-if="!isLoading" :icon="['far', 'magnifying-glass-plus']" class="mr-2" />
                    {{ !isLoading ? 'Nueva busqueda' : 'Cargando' }}
                </a-button>
            </div>
        </div>
        <ul class="details">
            <li class="detail-card" v-for="(item, index) in details" :key="index">
                <fa-icon :icon="['fas', item.icon]" />
                <div class="stats">
                    <apexchart
                        :ref="item.ref"
                        type="area"
                        width="100%"
                        height="50px"
                        :options="detailsOptions"
                        :series="item.series"
                    />
                </div>
                <p>{{ item.title }}</p>
                <h2>
                    {{ item.value }}
                    <span v-if="item.currency">€</span>
                    <fa-icon v-if="isLoading" :icon="['fal', 'spinner-third']" spin />
                </h2>
            </li>
        </ul>
        <section class="sells">
            <div class="sells-header">
                <h1>
                    Ventas Totales
                    <fa-icon v-if="isLoadingSells" :icon="['fal', 'spinner-third']" spin class="ml-2" />
                </h1>
                <ul v-if="false" class="periods">
                    <li>
                        <tag />
                    </li>
                </ul>
                <year-select
                    v-model="sellSeriesYears"
                    :minYear="$moment().year() - yearsInThePast"
                    placeholder="Añadir periodo"
                    :disabled="!provider || !provider.key"
                    @removed="handlerRemovedPeriod"
                    @added="handlerAddedPeriod"
                />
            </div>
            <div class="sells-content">
                <apexchart type="line" width="100%" :height="600" :options="sellsOptions" :series="sellsSeries" />
            </div>
        </section>
    </div>
</template>

<script>
import Actions from './_actions'
import Variables from './_variables'
import Checkbox from '@/application/components/checkbox.vue'
import Tag from '@/application/components/tag.vue'
import Apexchart from 'vue-apexcharts'
import YearSelect from '@/application/components/year-select.vue'

export default {
    mixins: [Actions],
    components: { Checkbox, Tag, YearSelect, Apexchart },
    data() {
        return Variables()
    },
}
</script>

<style scoped lang="scss">
@import './styles.scss';
</style>
